import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DataGridContext } from '../DataGrid/context';
import { Empty } from '@pattern-library/result';
const propTypes = {
  /**
   * Message to be shown when there are no rows to display
   */
  emptyMessage: PropTypes.string
};
const defaultProps = {
  emptyMessage: 'There aren’t any results that match your search.'
};
class DataGridEmpty extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  get currentState() {
    if (!this.context) {
      return {
        ...this.props,
        ...this.state
      };
    }
    const {
      visibleRows
    } = this.context;
    return {
      ...this.props,
      ...this.state,
      visibleRows
    };
  }
  render() {
    const {
      visibleRows
    } = this.currentState;
    const {
      emptyMessage
    } = this.props;
    return visibleRows.length === 0 && /*#__PURE__*/React.createElement(Empty, {
      className: "asc-grid-list-empty",
      title: emptyMessage,
      smallLayout: true
    });
  }
}
DataGridEmpty.propTypes = propTypes;
DataGridEmpty.defaultProps = defaultProps;
DataGridEmpty.contextType = DataGridContext;
export default DataGridEmpty;